// extracted by mini-css-extract-plugin
var _1 = "PostView-module__container--JmhOh";
export { _1 as "container" }
